import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  cardContainer: {
    background: "#ffffff",
    boxShadow: "0px 5px 15px 5px rgba(0, 0, 0, 0.1)",
    borderRadius: 15,
    paddingBlock: 20,
    paddingInline: 20,
    marginBlock: 20,
  },
  businessSettingsContainer: {
    padding: "20px",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    marginTop: 4,
    marginBottom: 24,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  headerIconBadge: {
    width: 44,
    height: 44,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EEF2FF",
    color: "#4338CA",
    "& .MuiSvgIcon-root": {
      fontSize: 24,
    },
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  titleBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  pageTitle: {
    fontWeight: 700,
    color: "#10212a",
  },
  pageSubtitle: {
    maxWidth: 820,
    color: "#5b6870",
    lineHeight: 1.5,
  },
  statusChip: {
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.4,
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: 16,
    marginBottom: 28,
  },
  statCard: {
    border: "1px solid #E5E9EF",
    borderRadius: 12,
    padding: "16px 18px",
    backgroundColor: "#FAFBFC",
  },
  statLabel: {
    color: "#5b6870",
    fontSize: 13,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  statValue: {
    marginTop: 6,
    fontWeight: 700,
    color: "#10212a",
    fontSize: 20,
  },
  noticeBox: {
    marginTop: 18,
    padding: 16,
    borderRadius: 12,
    border: "1px solid #cfe2ff",
    background: "linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%)",
  },
  noticeTitle: {
    fontWeight: 700,
    color: "#1d4ed8",
    marginBottom: 4,
  },
  noticeText: {
    color: "#334155",
    lineHeight: 1.6,
  },
  formGrid: {
    marginTop: 6,
  },
  fieldWrapper: {
    paddingBlock: 8,
  },
  primaryButton: {
    backgroundColor: theme.palette.custom.main,
    "&:hover": {
      backgroundColor: "#ec7905",
    },
  },
}));

export default useStyles;
